import { useLanguage } from "../../i18n/LanguageContext";
import { LANGUAGES } from "../../i18n/translations";

export const LanguageSwitcher = ({ tone = "dark" }) => {
  const { lang, setLang } = useLanguage();
  const active = tone === "dark" ? "text-forest" : "text-gold";
  const idle = tone === "dark" ? "text-charcoal/40 hover:text-charcoal/70" : "text-cream/50 hover:text-cream";

  return (
    <div data-testid="language-switcher" className="flex items-center gap-0.5 md:gap-1 text-[10px] md:text-xs font-semibold tracking-[0.1em] md:tracking-[0.15em]">
      {LANGUAGES.map((l, i) => (
        <span key={l.code} className="flex items-center">
          {i > 0 && <span className={tone === "dark" ? "text-charcoal/20" : "text-cream/20"}>/</span>}
          <button
            data-testid={`lang-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`px-1 md:px-1.5 py-1 transition-colors duration-200 ${lang === l.code ? active : idle}`}
          >
            {l.label}
          </button>
        </span>
      ))}
    </div>
  );
};
